import React from 'react';

import { Rating } from '@mui/material';
import { FaChevronDown } from 'react-icons/fa6';
import { Tooltip } from 'react-tooltip';

import star from '../../../assets/icons/star-smile.svg';
import CardFilters from 'components/specific/CardFilters';

import FeedbackModal from '../../specific/RatingQuestion/RatingQuestion';
import TimeFilterDropdown from '../timeFilterSelect/TimeFilterDropdown';
import { AppIcon } from '@common';
import { crossIcon } from '@src/assets/svg';

const StarIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 5.15377L9.07398 4.56218L6.99737 0L4.92077 4.56218L0 5.15377L3.638 8.57008L2.67593 13.5L6.99737 11.043L11.3241 13.5L10.362 8.57008L14 5.15377Z"
        fill="#F2AE40"
      />
    </svg>
  );
};

const RatingCard = ({
  reviewData,
  totalRating,
  setRatingFiter,
  state,
  date,
}) => {
  const [showReviews, setShowReviews] = React.useState(false);
  const [answer, setAnswer] = React.useState(null);
  const [isRatingOpen, setisRatingOpen] = React.useState(false);
  const [review, setReview] = React.useState(false);
  const [showQ, setShowQ] = React.useState(false);

  const openQuestion = (review) => {
    setisRatingOpen(true);
    setShowQ(true);
    setReview(review);
  };

  const ratingsGrouped = React.useMemo(() => {
    const grouped = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

    totalRating?.length > 0 &&
      totalRating.forEach((rating) => {
        const avg = Math.round(rating?.ratings[0]?.avg_rating || 0);
        if (avg >= 1 && avg <= 5) {
          grouped[avg] += 1;
        }
      });

    return grouped;
  }, [totalRating]);

  React?.useEffect(() => {
    if (totalRating?.length > 0) {
      setAnswer(totalRating?.[0]?.ratings?.[0]);
    }
  }, [totalRating]);

  return (
    <div>
      <FeedbackModal
        isRatingOpen={isRatingOpen}
        review={review}
        setIsRatingOpen={setisRatingOpen}
        showQ={showQ}
      ></FeedbackModal>
      <div className="w-full shadow-lg rounded-[20px] min-h-[464px] h-[100%] p-4 bg-white">
        <div className="flex justify-between items-center  pb-3">
          <div className="flex justify-center items-center gap-3 w-full">
            <div>
              <img src={star} alt="logo" />
            </div>
            <div className="flex justify-between items-center mb-3 w-full pt-1">
              <span class="text-[16px] font-medium">Overall Rating</span>
            </div>
          </div>
          <CardFilters />
        </div>
        {Object.entries(state[1]?.selectedList).length > 0 ? (
          <span className="ml-6 !bg-gray-200 text-grey-600   px-0.5	">
            <span className="dashboardFilters--showcase--selectedFilters--item--value">
              {state[1].title === 'Date'
                ? Object.values(state[1].selectedList || {}).join(',')
                : Object.keys(state[1].selectedList || {}).join(',')}
            </span>
            <AppIcon
              icon={crossIcon}
              onClick={() => {
                if (state[1].title === 'Date') {
                  date.removeDate();
                }
              }}
              className="dashboardFilters--showcase--selectedFilters--item--icon"
            />
          </span>
        ) : (
          console.log('state-have is empty', state[1])
        )}

        <div>
          <div className="flex justify-between border-b border-t pb-4">
            <div className="flex gap-3">
              <h3 className="text-[40px] font-medium mt-1.5">
                {totalRating?.length > 0 &&
                totalRating[0]?.physician?.avg_rating
                  ? Number(totalRating[0].physician.avg_rating).toFixed(1)
                  : '0'}
              </h3>
              <div className="mt-2.5 h-[50px] w-[1px] bg-[#E2E4E9]" />
              <div className="mt-2">
                <Rating
                  name="read-only"
                  value={
                    totalRating?.length > 0 &&
                    totalRating[0]?.physician?.avg_rating
                      ? Number(totalRating[0].physician.avg_rating).toFixed(1)
                      : 'N/A'
                  }
                  readOnly
                  precision={0.5}
                />

                <p className="font-medium text-[#525866] underline cursor-pointer">
                  {/*  {totalRating?.[0]?.physician?.avg_rating.length} reviews*/}
                </p>
              </div>
            </div>
            <div
              className={`text-[#525866] self-center cursor-pointer mt-[-32px] border rounded px-[5.42px] py-[5.42px] `}
              onClick={() => setShowReviews(!showReviews)}
            >
              <FaChevronDown
                className={`h-[9.55px] w-[9.55px] transition delay-50 duration-200 ease-in-out ${showReviews ? 'rotate-180' : ''}`}
              />
            </div>
          </div>
          {showReviews && (
            <div className="space-y-4 mb-6 mt-6 overflow-y-auto h-[300px]">
              {totalRating?.map((review, index) => (
                <div
                  key={index}
                  className="border-b pb-2 cursor-pointer"
                  onClick={() => openQuestion(review)}
                >
                  <div className="flex justify-between">
                    <h3 className="font-medium text-sm">
                      {review?.ratings[0]?.hospital_manager?.firstName}{' '}
                      {review?.ratings[0]?.hospital_manager?.lastName}
                    </h3>
                    {/*<p className="text-xs font-normal text-gray-500">{review?.ratings[0]?.created_at}</p>*/}
                  </div>
                  <div className="flex gap-2">
                    <Rating
                      name={`rating-${index}`}
                      value={
                        totalRating?.length > 0 &&
                        totalRating[0]?.physician?.avg_rating
                          ? Number(totalRating[0].physician.avg_rating).toFixed(
                              1
                            )
                          : 'N/A'
                      }
                      readOnly
                      precision={0.5}
                      size="medium"
                    />
                    <p className="text-sm font-normal text-gray-600">
                      ({review?.ratings[0]?.avg_rating})
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="mt-[20px]">
            <div className="space-y-4">
              {[5, 4, 3, 2, 1].map((star) => (
                <div key={star} className="space-y-2">
                  <div className="flex items-center gap-3">
                    <div className="w-full bg-[#F6F8FA] h-[12px] rounded-md relative">
                      <div
                        // style={{
                        //     width: `${(ratingsGrouped[star] / totalRating.length) * 100}%`,
                        // }}
                        className="bg-[#F2AE40] h-[12px] rounded-md"
                      ></div>
                    </div>
                    <span className="text-sm font-normal">
                      {star}
                      <span
                        className="text-sm text-gray-600 cursor-pointer"
                        data-tooltip-id={`tooltip-${star}`}
                      >
                        ({ratingsGrouped[star]})
                      </span>
                    </span>
                    <StarIcon className="h-4 w-4 text-yellow-500" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingCard;
